import { useState, useCallback, useEffect, type ReactNode } from 'react';
import { LandscapeContext } from './landscape';

type OverlayMode = 'normal' | 'rotate' | 'rotate-instant' | 'suppressed';

export function LandscapeProvider({ children }: { children: ReactNode }) {
  const [mode, setMode] = useState<OverlayMode>('normal');

  const suppress = useCallback(() => setMode('suppressed'), []);
  const unsuppress = useCallback(() => setMode('normal'), []);
  const showRotatePrompt = useCallback((instant?: boolean) => {
    setMode(instant ? 'rotate-instant' : 'rotate');
  }, []);

  // Reset to normal mode when user rotates to portrait
  useEffect(() => {
    const handleOrientationChange = () => {
      const isPortrait = window.innerHeight > window.innerWidth;
      if (isPortrait && (mode === 'rotate' || mode === 'rotate-instant')) {
        setMode('normal');
      }
    };

    window.addEventListener('resize', handleOrientationChange);
    window.addEventListener('orientationchange', handleOrientationChange);
    
    return () => {
      window.removeEventListener('resize', handleOrientationChange);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, [mode]);

  return (
    <LandscapeContext.Provider value={{ mode, suppress, unsuppress, showRotatePrompt }}>
      {children}
    </LandscapeContext.Provider>
  );
}
